import { Injectable } from '@angular/core';
import { IMultiselectListItem } from 'multi-select-autocomplete-lib';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BullhornEntityFiltersService } from '../bullhorn.entity-filters.service';

@Injectable({ providedIn: 'root' })
export class BullhornCompanyFiltersService extends BullhornEntityFiltersService {
  override entity = 'ClientCorporation';
  override entityPath = ['bullhorn', 'ClientCorporation'];
  override percentageFields = ['taxRate', 'feeArrangement'];

  override unsupportedTypes = ['TO_MANY', 'COMPOSITE'];
  override unsupportedDataTypes = ['Timestamp'];
  override relationshipFields = [
    { name: 'id', queryFunction: this.queryForCompanies.bind(this) },
    { name: 'billingContact', queryFunction: this.queryForContacts.bind(this) },
    { name: 'parentClientCorporation', queryFunction: this.queryForCompanies.bind(this) },
    { name: 'department', queryFunction: this.queryForDepartments.bind(this) },
  ];

  private queryForCompanies(keyword: string): Observable<IMultiselectListItem[]> {
    return this.executeQuery('ClientCorporation', ['id', 'name'], keyword);
  }

  private queryForContacts(keyword: string): Observable<IMultiselectListItem[]> {
    return this.executeQuery('ClientContact', ['id', 'name'], keyword, 'AND isDeleted:false', 'AND isDeleted = false');
  }

  private queryForDepartments(keyword: string): Observable<IMultiselectListItem[]> {
    console.log('Querying for departments with keyword:', keyword);
    if (!keyword || !keyword.trim().length) {
      return of([]);
    }

    keyword = keyword.trim();
    const isKeywordDigitOnly = BullhornEntityFiltersService.DIGIT_REGEX.test(keyword);
    const isKeywordDigitSeparated = BullhornEntityFiltersService.COMMA_SEPARATED_DIGITS_REGEX.test(keyword);
    const keywordDigitsSeparatedByCommas = isKeywordDigitSeparated ? keyword.split(',').map((k) => k.trim()) : [];

    const query = 'id > 0 AND enabled=true';
    const fields = 'id,name';

    return this.dataSourceApiService.query2('CorporationDepartment', { query: query, fields: fields }).pipe(
      map((response) => {
        return response
          .map((record) => ({
            id: record.id,
            label: record.name,
            data: record,
          }))
          .filter((dept) => {
            if (isKeywordDigitOnly) {
              return dept.id.toString() === keyword;
            } else if (isKeywordDigitSeparated) {
              return keywordDigitsSeparatedByCommas.includes(dept.id.toString());
            } else {
              return dept.label.toLowerCase().includes(keyword.toLowerCase());
            }
          });
      })
    );
  }
}
